import React from 'react';

export default function Title(props) {
  const { Type } = props;
  return <h3>{Type ? (Type == 'Facility' ? 'Linked Securities' : 'Linked Facilities') : ''}</h3>;
}
